<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <transition name="fade">
        <div class="col-sm-12 list-content nopads">
                <b-card v-for="user in results"
                        v-bind:key="user.id"
                        class="mt-2"
                        :title="user.lastName + ', ' + user.firstName"
                >
                    <b-card-text>
                        {{ user.email }}
                    </b-card-text>
                    <div class="round-btn" @click.stop="$emit('edit', user)"><font-awesome-icon icon="pencil-alt"/></div>
                </b-card>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'user-list',
        props: {
            results: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        data() {
            return {
            }
        },
        methods: {
        }
    }
</script>
